import React from "react";
import { Button, Row, Col } from "react-bootstrap";
import { useAuthState } from "../../../context/AuthContext";
import EnergoTooltip from "../../shared/Tooltip";


/**
 * 
 * @param {param} setStage setter for changing stage/view
 * @param {param} setData setter for object data
 * 
 * @returns no/yes button
 */
const QuestionRegisterStage = ({setStage, setData}) => {

    const { tooltips, tooltipsTrigger } = useAuthState();

    return (
        <Row className="mt-5">
            <Col xl="12" className="text-center mb-5">
                <div style={{display: "flex", justifyContent: "center"}}>
                    <p style={{marginRight: 10}}>Möchten Sie die Anlage bei Energielieferant anmelden?</p>
                    {tooltipsTrigger?
                        tooltips.find(t => t.code === 106) !== undefined?
                            <EnergoTooltip text={tooltips.find(t => t.code === 106).help_text} position="right" /> : null
                    :null}  
                </div>
                <Button onClick={() => {setData((prev) => ({...prev, register: false})); setStage("summary") }} style={{width: "250px", marginRight: "10px"}} className="btn-energo"><b>NEIN</b> <br /> Anlage nur speichern</Button>
                <Button onClick={() => {setData((prev) => ({...prev, register: true})); setStage("register_data") }} style={{width: "250px"}} className="btn-energo"><b>JA</b> <br/> Anlage anmelden</Button>
            </Col>
        </Row>
    )
}
export default QuestionRegisterStage;